/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {FocusableOption, FocusOrigin} from '@angular/cdk/a11y';
import {CdkStepHeader} from "@angular/cdk/stepper";

@Component({
    selector: 'app-wizard-header',
    templateUrl: './wizard-header.component.html',
    styleUrls: ['./wizard-header.component.css'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class WizardHeaderComponent extends CdkStepHeader implements  OnInit, FocusableOption {
    @Input() label: string;
    @Input() index: number;
    @Input() selected: boolean;
    @Input() active: boolean;
    @Input() optional: boolean;
    @Input() isValidForSave: boolean;
    @Input() isValidForSend: boolean;
    @Input() formSubmitted: boolean;

    @Input() hasSuccessIcon: boolean;
    @Input() hasWarningIcon: boolean;
    @Input() hasErrorIcon: boolean;

    constructor(private _element: ElementRef) {
        super();
    }

    ngOnInit(): void {
    }

    focus(origin?: FocusOrigin): void {
        return this._element.nativeElement.focus();
    }

    getTooltipString(): string {
        let tooltipString;
        if (this.hasSuccessIcon) {
            tooltipString = 'Everything is filled correctly';
        }
        if (this.hasWarningIcon) {
            tooltipString = 'Some information needs your attention';
        }
        if (this.hasErrorIcon) {
            tooltipString = 'One or more required for send fields are empty';
        }
        return tooltipString;
    }
}
